import Skill from '../skill';

/**
 * Create the action
 */

const { thunk, request, success, error } = Skill.index((fetch) => {
    return fetch.get('/skills');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
